import { render, staticRenderFns } from "./BroadcastCard.vue?vue&type=template&id=54226605&scoped=true"
import script from "./BroadcastCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BroadcastCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BroadcastCard.vue?vue&type=style&index=0&id=54226605&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54226605",
  null
  
)

export default component.exports